<template v-if="data.id != 'temp'">
  <!-- <div :style="`padding:${padding}px`" style="display: flex;flex-direction: column;align-items: center;" :class="Object.hasOwn(data, 'show')&&!data.show?'invisible':''" > -->
  <div :style="type == 'big' ? 'padding:10px' : ''" style="width:200px;display: flex;flex-direction: column;align-items: center;"
    :class="Object.hasOwn(data, 'show') && !data.show ? 'invisible' : ''">
    <!-- <div style=" text-align:center;" class="color"
      :style="`background-color:${data.hexColor};width:${width}px;height:${height}px;`">
    </div> -->
    <div v-if="data.taxonomy=='pa_colore'" style=" text-align:center;" class="color"
      :style="type=='big'?`width:100px;height:100px;background-color:${data.hexColor}`:`width:50px;height:50px;background-color:${data.hexColor}`"
      >
    </div>
    <div v-if="data.taxonomy=='pa_texture'" style=" text-align:center;" class="color"
      :style="type=='big'?`width:100px;height:100px;background-image:url(${data.hexColor})`:`width:50px;height:50px;background-image:url(${data.hexColor})`"
      >
    </div>
    <h5 v-if="type=='big'" style="text-align: center;font-size:medium">{{ data.name }}</h5>
    <h5 v-else style="text-align: center;font-size:medium">{{ data.name }}</h5>
  </div>
</template>
<script>
export default {
  name: 'BaseColor',
  props: {
    data: Object,
    height: Number,
    width: Number,
    padding: Number,
    type: String
  },
  setup() {
    const imgPath = window.location.origin + "/wp-content/plugins/loggiaColors/views/img/";
    // const imgPath = "http://localhost:80/wp-content/plugins/loggiaColors/views/img/";
    const styleBackgroundLoading = "url('" + imgPath + "goccia.png')";
    return { styleBackgroundLoading }
  }

}
</script>
<style scoped>
.circle {
  display: block;
  border-radius: 50%;
  height: 200px;
  width: 200px;
  margin: 0;
}

.invisible {
  display: none !important;
}

.ball {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 50%;
  position: relative;
  background: radial-gradient(circle at 50% 120%, #323232, #0a0a0a 80%, #000000 100%);
}

.ball:before {
  content: "";
  position: absolute;
  background: radial-gradient(circle at 50% 120%, rgba(255, 255, 255, 0.205), rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  bottom: 2.5%;
  left: 5%;
  opacity: 0.6;
  height: 100%;
  width: 90%;
  -webkit-filter: blur(5px);
  z-index: 2;
}

.ball:after {
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  top: 67%;
  left: 66%;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 50%, hsla(0, 0%, 100%, .8), hsla(0, 0%, 100%, .8) 14%, hsla(0, 0%, 100%, 0) 24%);
  transform: translateX(-80px) translateY(-90px) skewX(0deg);
  -webkit-filter: blur(10px);
}

.ball .shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0) 50%);
  -webkit-transform: rotateX(90deg) translateZ(-150px);
  -moz-transform: rotateX(90deg) translateZ(-150px);
  -ms-transform: rotateX(90deg) translateZ(-150px);
  -o-transform: rotateX(90deg) translateZ(-150px);
  transform: rotateX(90deg) translateZ(-150px);
  z-index: -1;
}

.stage {
  width: 100px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  -webkit-perspective: 1200px;
  -moz-perspective: 1200px;
  -ms-perspective: 1200px;
  -o-perspective: 1200px;
  perspective: 1200px;
  -webkit-perspective-origin: 50% 50%;
  -moz-perspective-origin: 50% 50%;
  -ms-perspective-origin: 50% 50%;
  -o-perspective-origin: 50% 50%;
  perspective-origin: 50% 50%;
}

.color {
  position: relative
}

.color:after {
  background-image: v-bind(styleBackgroundLoading);
  background-size: cover;
  content: "";
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  position: absolute;
}</style>